import {
  Components,
  menuClasses,
  menuItemClasses,
  paperClasses,
  Theme,
} from '@mui/material';

export function getMuiMenu(theme: Theme): Components['MuiMenu'] {
  return {
    styleOverrides: {
      paper: {
        [`&.${paperClasses.elevation}`]: {
          marginTop: theme.spacing(2),
          borderRadius: theme.shape.borderRadius,
          backgroundImage: 'none',
          boxShadow:
            '0px 3px 16px 0px rgba(0, 0, 0, 0.12), 0px 5px 12px 0px rgba(0, 0, 0, 0.14), 0px 5px 5px 0px rgba(0, 0, 0, 0.16)',

          [`& .${menuClasses.list}`]: {
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(1),
            padding: theme.spacing(1),
          },

          [`& .${menuItemClasses.root}`]: {
            borderRadius: theme.shape.borderRadiusMd, // ex 14
            minHeight: theme.spacing(10),
          },
        },
      },
    },
  };
}
